import React, { ReactNode } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CustomizedSwitches from 'view/components/Switch';
import useTheme from 'hooks/theme';
import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import LanguageChange from 'view/components/LanguageChange';
import Divider from '@mui/material/Divider';
import MuiLink from '@mui/material/Link';
import { DONATE_PATH, LIVE_DONATE_PATH } from 'view/routes';
import { useTranslation } from 'react-i18next';
import useUser from 'hooks/user';
import Button from 'view/components/Button';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

type DrawerDetailsProps = {
  adminTabs: Array<{
    id: string;
    onClick: () => void;
    icon: ReactNode;
    label: string;
  }>;
  onClose: () => void;
};

const DrawerDetails = ({ adminTabs, onClose }: DrawerDetailsProps) => {
  const { user, OBSUrl } = useUser();
  const { toggleTheme, isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={{ width: 300 }} mt="4rem">
      <Box mb={2}>
        <List>
          {adminTabs.map((page, index) => (
            <ListItem key={page.id} disablePadding>
              <ListItemButton
                onClick={() => {
                  page.onClick();
                  onClose();
                }}
              >
                <ListItemIcon>{page.icon}</ListItemIcon>
                <ListItemText primary={page.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
      <Box mb={2}>
        <Divider />
      </Box>
      <Box px={2} mb={2} gap={1} display="flex" flexDirection="column">
        <MuiLink
          href={`${process.env.REACT_APP_UI_URL}${DONATE_PATH}/${user.contentCreatorName}`}
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            variant="outlined"
            label={t('My page')}
            endIcon={<OpenInNewRoundedIcon />}
          />
        </MuiLink>
        <MuiLink
          href={`${process.env.REACT_APP_UI_URL}/${OBSUrl}${LIVE_DONATE_PATH}`}
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            variant="outlined"
            label={t('OBS widget')}
            endIcon={<OpenInNewRoundedIcon />}
          />
        </MuiLink>
      </Box>

      <Box px={2} mb={2}>
        <LanguageChange />
      </Box>
      <Box px={1} mb={2}>
        <CustomizedSwitches onChange={toggleTheme} checked={isDarkMode} />
      </Box>
    </Box>
  );
};
export default DrawerDetails;
